<app-multiple-drugs-dialog-base header="Receiving" [dialogType]="dialogType"
  (cancel)="cancel.emit()" (save)="receiveDrug($event)"
  (validateForm)="validateOrderForm()"
  drugScannerLabel="Which drug are you receiving?" submitBtnText="Receive"
  [selectedDrug]="selectedDrug"
  [excludedLocations]="excludedLocations"
  [activityType]="ActivityTypesEnum.Received"
  [hideHeaderUnderline]="true" [limitDrugSearchToPharmacy]="false"
  [maxValueExceededErrorMessage]="maxValueExceededErrorMessage">
  <div class="sub-header" subHeader>
    For bulk receiving use the <a class="sub-header-link" (click)="navigateToBulkAdd()">bulk add</a> feature
  </div>
  <app-enter-order class="block mt-4" #enterOrderComponent
  ></app-enter-order>
</app-multiple-drugs-dialog-base>